import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-surface" data-id="element-11">
      <div className="max-w-7xl mx-auto px-6" data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-13">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-14">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-15">Про нас</h2>
            <p className="text-lg text-secondary leading-relaxed mb-6 font-medium text-primary" data-id="element-16">
              Ми не обіцяємо неможливого, але витискаємо максимум з букви
              закону. Наша команда об'єднує експертів з різних галузей права, що
              дозволяє вирішувати комплексні проблеми на стику особистих,
              фінансових та державних спорів.
            </p>
            <p className="text-lg text-secondary leading-relaxed" data-id="element-17">
              З 2022 року ми сфокусувалися на захисті прав громадян в умовах
              турбулентності: від проходження ВЛК та захисту від неправомірних
              дій ТЦК до повного списання боргів та важких поділів майна. Ми
              знаємо не тільки теорію, але й внутрішню кухню судів, держорганів
              та виконавчих служб.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6" data-id="element-18">
            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-19">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-20">
                &gt; 5 років
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-21">
                Середній досвід адвокатів у ключових практиках
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-22">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-23">
                24/7
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-24">
                На зв'язку для екстрених питань та захисту при затриманнях
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-25">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-26">
                94%
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-27">
                Успішно вирішених справ та підписаних мирових угод
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-28">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-29">
                100%
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-30">
                Конфіденційність. Ваші дані захищені адвокатською таємницею
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}